export var getMapLink = function getMapLink(geoInfo) {
  var query = "//cian.ru/map/?deal_type=sale&engine_version=2&zoom=12&with_newobject=1&newbuildings_search=true";
  if (geoInfo) {
    var regionId = geoInfo.regionId,
      _geoInfo$coordinates = geoInfo.coordinates,
      lat = _geoInfo$coordinates.lat,
      lng = _geoInfo$coordinates.lng;
    query += "&region=".concat(regionId, "&center=").concat(lat, ",").concat(lng);
  }
  return query;
};